import { atom } from "jotai";

// 회원탈퇴 단계 스택 (현재 step = 마지막 요소)
//   1: 약관 동의
//   2: 사유 선택
//   3: 최종 확인
//   4: 완료
export const withdrawStepStackAtom = atom<number[]>([1]);

export const withdrawStepAtom = atom((get) => {
    const stack = get(withdrawStepStackAtom);
    return stack[stack.length - 1] ?? 1;
});

// 단계 push (브라우저 history에도 push하여 물리 뒤로가기 지원)
export const pushWithdrawStepAtom = atom(
    null,
    (get, set, nextStep: number) => {
        const stack = get(withdrawStepStackAtom);
        set(withdrawStepStackAtom, [...stack, nextStep]);
        history.pushState({ withdrawStep: nextStep }, "");
    }
);

// 단계 pop (이전으로). 더 이상 뒤로 갈 수 없으면 null
export const popWithdrawStepAtom = atom(
    null,
    (get, set): number | null => {
        const stack = get(withdrawStepStackAtom);
        if (stack.length <= 1) return null;
        const newStack = stack.slice(0, -1);
        set(withdrawStepStackAtom, newStack);
        return newStack[newStack.length - 1];
    }
);

// 단계 replace (현재 step을 다른 단계로 치환 — 약관 0개일 때 Step1 → Step2 등)
// 뒤로가기 시 치환 전 단계로 돌아가지 않게 history도 replace
export const replaceWithdrawStepAtom = atom(
    null,
    (_get, set, nextStep: number) => {
        set(withdrawStepStackAtom, [nextStep]);
        history.replaceState({ withdrawStep: nextStep }, "");
    }
);

// 동의한 약관 항목
export interface TermsConsentItem {
    termsId: number;
    termsVersion: string;
}

// 회원탈퇴 데이터
export interface WithdrawData {
    termsConsents: TermsConsentItem[];   // 동의한 약관들 (감사 로그용 — 백엔드 전달 시 활용 가능)
    reason: string;                      // 탈퇴 사유 (key: notUseful/privacy/.../other 또는 사용자 입력)
    feedback: string;                    // "기타" 선택 시 추가 의견
    finalConfirmed: boolean;             // 최종 동의 체크
}

const initialWithdrawData: WithdrawData = {
    termsConsents: [],
    reason: "",
    feedback: "",
    finalConfirmed: false,
};

export const withdrawDataAtom = atom<WithdrawData>(initialWithdrawData);

// 초기화
export const resetWithdrawData = atom(
    null,
    (_get, set) => {
        set(withdrawDataAtom, initialWithdrawData);
        set(withdrawStepStackAtom, [1]);
    }
);
